// @ts-nocheck

export const localeCodes =  [
  "en",
  "sv"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46js_532610f4",
      load: () => import("#nuxt-i18n/532610f4" /* webpackChunkName: "locale_en_46js_532610f4" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46js_a8782222",
      load: () => import("#nuxt-i18n/a8782222" /* webpackChunkName: "locale_sv_46js_a8782222" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    name: "English",
    code: "en",
    language: "en-US"
  },
  {
    name: "Swedish",
    code: "sv",
    language: "sv-SE"
  }
]

